function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Avatar, Button, HStack, Icon, MenuButton, Stack, Text } from '@chakra-ui/react';
import { UserMenu } from '@/components/UserMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import useChannelStore from '@/stores/ChannelStore';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { FormattedMessage } from 'react-intl';
import useLoginRedirect from '@/hooks/useLoginRedirect';
import { useShallow } from 'zustand/react/shallow';
function UserMenuButton(props) {
    var _useChannelStore = useChannelStore(useShallow(function(state) {
        return {
            channel: state.channel,
            channelLoading: state.channelLoading
        };
    })), channel = _useChannelStore.channel, channelLoading = _useChannelStore.channelLoading;
    var user = useAuthenticationStore(function(state) {
        return state.user;
    });
    var loginRedirect = useLoginRedirect();
    if (channel == null && !channelLoading) {
        return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, props), {
            leftIcon: /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: faRightFromBracket
            }),
            onClick: loginRedirect,
            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "AyGauy",
                defaultMessage: "Login"
            })
        }));
    }
    return /*#__PURE__*/ _jsx(UserMenu, {
        matchWidth: true,
        placement: "top",
        children: /*#__PURE__*/ _jsx(MenuButton, _object_spread_props(_object_spread({
            as: Button,
            borderRadius: "lg",
            gap: 4,
            minHeight: 14,
            variant: "outline"
        }, props), {
            children: /*#__PURE__*/ _jsxs(HStack, {
                alignItems: "center",
                spacing: 2,
                minWidth: 0,
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        size: "sm",
                        src: channel === null || channel === void 0 ? void 0 : channel.avatar
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 0,
                        textAlign: "left",
                        lineHeight: "1.1rem",
                        minWidth: 0,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                isTruncated: true,
                                children: channel === null || channel === void 0 ? void 0 : channel.displayName
                            }),
                            user != null && channel != null && (user === null || user === void 0 ? void 0 : user._id) !== (channel === null || channel === void 0 ? void 0 : channel._id) ? /*#__PURE__*/ _jsx(Text, {
                                color: "textSecondary",
                                fontSize: "sm",
                                isTruncated: true,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "27Bdra",
                                    defaultMessage: "viewing as {displayName}",
                                    values: {
                                        displayName: user === null || user === void 0 ? void 0 : user.displayName
                                    }
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Icon, {
                        ml: "auto",
                        as: FontAwesomeIcon,
                        icon: faEllipsisV
                    })
                ]
            })
        }))
    });
}
export default UserMenuButton;
